const SectionTwo = () => {
  return (
    <div
      className="section-two position-relative d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: "url('/images/Background (1).jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
    >
      {/* WHITE OVERLAY */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.57)",
          zIndex: 1,
        }}
      />

      {/* CONTENT */}
      <div className="position-relative z-2 text-center">
        <img src="/images/howwork.png" alt="How it works" />
      </div>
    </div>
  );
};

export default SectionTwo;
